import {Role} from './competitor';

export class LoggedCompetitor {
  id: number;
  firstName: string;
  lastName: string;
  role: Role;
  userId: number;

  constructor(
    id = null,
    firstName = '',
    lastName = '',
    role = Role.USER,
    userId = null
  ) {
    this.id = id;
    this.firstName = firstName;
    this.lastName = lastName;
    this.role = role;
    this.userId = userId;
  }
}
